module.exports = __webpack_public_path__ + "img/komodo-dragon.81732cbc.png";